import React from 'react';
import {Notification} from '../navigation/page-layout';
import {ModelExplainer} from './model-explainer';
import {FOUNDATION_EXPLAINER_CONFIG} from './model-explainer-configs';

export function FoundationExplainer(props: {pushNotification: (notification: Notification) => void}) {
    return <ModelExplainer config={FOUNDATION_EXPLAINER_CONFIG} pushNotification={props.pushNotification} />;
}
